export const actionTypes = {
    SET_ERROR_TYPE: 'error/SET_ERROR_TYPE',
    SET_ERROR_MESSAGE: 'error/SET_ERROR_MESSAGE',
    SET_ERROR_CONTENT: 'error/SET_ERROR_CONTENT',
    BATCH_ERROR: 'error/BATCH_ERROR',
    SET_PAGE_NAME: 'error/SET_PAGE_NAME',
    SET_ERROR: 'error/SET_ERROR',
};
